export default "__VITE_ASSET__7qfKeO2G__"